import React from 'react';

export default function IDChoiceStep({ onChoose }) {
  return (
    <div className="step-1">
      <h3>How would you like to proceed with Interior Design?</h3>
      <div className="id-choice-container">
        <div className="id-choice-card" onClick={() => onChoose('enquiry')}>
          <div className="id-choice-icon">&#9993;</div>
          <h4>Enquiry</h4>
          <p>Tell us about your interior design needs and our team will get back to you.</p>
        </div>
        <div className="id-choice-card" onClick={() => onChoose('booking')}>
          <div className="id-choice-icon">&#128197;</div>
          <h4>Book &amp; Pay</h4>
          <p>Schedule a briefing session with our interior design specialists and pay online.</p>
        </div>
      </div>
    </div>
  );
}
